import { useQuery } from '@tanstack/react-query';
import { getMyAdminProfile } from '@/api/admins';
import type { GetMyAdminProfileResponse } from '@gokrew/models/admins';
import { QueryKeys } from '@gokrew/models/constants';

export function useProfile(options?: { enabled?: boolean }) {
  return useQuery<GetMyAdminProfileResponse>({
    queryKey: [QueryKeys.Profile],
    queryFn: getMyAdminProfile,
    enabled: options?.enabled ?? true,
  });
}